type LookupKind = 'stash' | 'entity';

export interface CollectionLookupItem {
  type: string;
  id: string;
}

export type CollectionReverseLookupKey =
  | readonly ['collections-for-stash', string]
  | readonly ['collections-for-entity', string];

const LOOKUP_PREFIX_BY_TYPE: Record<LookupKind, CollectionReverseLookupKey[0]> = {
  stash: 'collections-for-stash',
  entity: 'collections-for-entity',
};

function buildLookupKey(type: string, id: string): CollectionReverseLookupKey | null {
  const normalizedType = type.toLowerCase();
  if (normalizedType !== 'stash' && normalizedType !== 'entity') {
    return null;
  }
  const trimmedId = id.trim();
  if (!trimmedId) {
    return null;
  }
  return [LOOKUP_PREFIX_BY_TYPE[normalizedType], trimmedId] as const;
}

function dedupeKeys(keys: Array<CollectionReverseLookupKey | null>): CollectionReverseLookupKey[] {
  const seen = new Set<string>();
  const result: CollectionReverseLookupKey[] = [];
  for (const key of keys) {
    if (!key) {
      continue;
    }
    const stable = `${key[0]}:${key[1]}`;
    if (seen.has(stable)) {
      continue;
    }
    seen.add(stable);
    result.push(key);
  }
  return result;
}

export function collectionReverseLookupKeysForItems(items: CollectionLookupItem[]): CollectionReverseLookupKey[] {
  return dedupeKeys(items.map((item) => buildLookupKey(item.type, item.id)));
}

export function collectionReverseLookupKeysForItemKeys(itemKeys: string[]): CollectionReverseLookupKey[] {
  return dedupeKeys(itemKeys.map((itemKey) => {
    const separator = itemKey.indexOf('#');
    if (separator <= 0) {
      return null;
    }
    const type = itemKey.slice(0, separator);
    const id = itemKey.slice(separator + 1);
    return buildLookupKey(type, id);
  }));
}
